var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodyMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 265,
    viewBox: "0 0 135 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.9549 202.282C85.8572 202.697 85.4418 202.942 85.1975 202.991C84.0248 203.308 84.2446 204.285 84.3912 204.97C84.7577 206.778 84.6356 208.61 84.5134 210.394C84.3179 213.252 83.8293 216.086 83.4872 218.945C83.1941 221.437 82.5832 223.856 81.7037 226.177C81.0929 227.814 80.9463 229.573 80.2133 231.161C78.503 234.875 77.8434 238.882 76.8416 242.766C76.2064 245.185 76.4018 247.8 76.6462 250.316",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9414 202.38C50.088 202.527 50.2102 202.771 50.3812 202.795C51.7005 202.942 51.5784 203.944 51.4318 204.75C51.0897 206.778 51.1875 208.806 51.3585 210.809C51.6761 214.67 52.238 218.481 52.9466 222.293C53.3375 224.345 54.3881 226.202 54.779 228.254C55.3165 231.015 56.7092 233.507 57.2956 236.268C57.8819 239.029 58.9325 241.692 59.2013 244.502C59.3723 246.358 59.2257 248.24 59.2257 250.121",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.475 143.4C87.6216 147.26 87.9636 151.12 87.7926 154.981C87.6216 158.621 87.4506 162.286 86.2778 165.804C85.3249 168.736 84.2255 171.644 83.2726 174.575C82.1243 178.094 81.2692 181.71 80.7561 185.399C80.7072 185.692 80.7561 185.985 80.7561 186.254",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.306 143.4C48.1839 146.869 47.8663 150.314 47.9884 153.783C48.135 158.548 48.5504 163.214 50.1873 167.759C51.0913 170.275 52.1908 172.719 52.826 175.308C53.6812 178.851 54.8295 182.345 55.0249 186.01",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4267 161.382C59.9869 164.362 58.7897 167.172 58.2766 170.153C57.617 173.891 57.3482 177.654 58.1545 181.416C58.4477 182.833 59.2539 184.006 60.329 184.861C61.7216 185.936 63.7251 185.081 64.4092 183.908C64.5069 183.737 64.5063 183.784 64.7512 183.493",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4729 161.602C75.6684 164.167 76.5479 166.61 77.232 169.054C77.7451 170.837 77.9161 172.67 78.0139 174.478C78.1605 176.848 78.2338 179.266 77.6229 181.612C77.2809 182.907 76.5479 183.982 75.5706 184.861C74.2268 186.059 71.8813 185.277 71.2461 183.469",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9824 102.72C28.6124 106.8 25.2408 110.147 22.5043 113.934C20.5986 116.573 19.0838 119.431 17.2514 122.07C15.8099 124.147 14.1729 126.028 12.3649 127.787C11.7785 128.349 10.9967 128.642 10.2148 128.887",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.016 102.94C106.286 105.774 108.583 107.875 110.415 110.294C113.005 113.739 115.644 117.159 117.72 120.971C119.089 123.512 121.165 125.564 123.12 127.69C123.755 128.374 124.659 128.765 125.588 129.009",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9656 119.383C89.9656 120.727 89.9656 122.046 89.9656 123.39C89.9411 126.175 90.5275 128.863 91.3582 131.502C92.0912 133.823 92.5554 136.241 92.9952 138.636C93.3861 140.737 93.7282 142.863 93.6549 145.013C93.6304 145.477 93.6793 145.966 93.5571 146.43",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8138 119.164C45.8138 120.606 45.8138 122.047 45.8138 123.489C45.7894 125.981 45.2519 128.351 44.5678 130.745C43.6882 133.75 43.0285 136.829 42.5399 139.932C42.2711 141.74 42.1001 143.523 42.1489 145.356C42.1489 145.649 42.1001 145.942 42.2467 146.211",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.57 104.676C107.233 108.536 110.19 112.176 113.097 115.841C115.027 118.26 116.469 120.996 118.081 123.635C119.156 125.394 119.816 127.276 119.816 129.377C119.816 129.841 119.718 130.281 119.474 130.672",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2045 104.676C28.3703 108.585 25.2918 112.323 22.3599 116.159C20.1122 119.091 18.2553 122.267 16.6428 125.59C15.9587 127.007 15.5922 128.668 16.1541 130.33",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2148 65.2908C41.2427 66.9033 43.5638 67.7829 46.1292 67.9783C49.1344 68.2227 51.9197 67.2454 54.8027 66.6101C56.8795 66.1459 58.9318 65.584 61.0818 65.5107",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5808 65.4856C94.0887 67.2447 91.3034 68.222 88.2494 68.1732C86.5147 68.1487 84.8533 67.6601 83.1675 67.2447C80.3822 66.5606 77.6213 65.8032 74.7383 65.6078",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0695 135.192C64.8479 137.733 64.6035 140.543 63.8217 143.206C62.7222 146.944 62.3313 150.804 62.0626 154.665C62.0137 155.251 61.9893 155.813 61.9648 156.399",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2461 45.7932C43.6143 46.0864 44.9825 45.7688 46.3507 45.9887C48.2809 46.3307 50.2355 46.5995 52.1901 46.8682C54.4134 47.1859 56.6368 47.4302 58.7868 48.0654C60.2772 48.5052 61.7431 48.9939 63.2335 49.4581",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8516 135.509C70.5845 136.951 70.8044 138.514 71.1465 140.053C71.7817 142.839 72.7346 145.551 73.0766 148.385C73.3698 150.877 73.679 152.546 73.9478 155.039M73.9478 155.039C73.9722 155.21 73.9722 154.868 73.9478 155.039Z",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5538 46.0128C90.4997 45.5975 87.5434 46.3793 84.5871 46.7947C81.8995 47.1612 79.1875 47.4543 76.5732 48.285C75.2783 48.7004 73.9345 49.0424 72.6641 49.58",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6016 60.0862C81.3869 61.5277 83.8301 63.4823 86.7131 64.7528C90.2558 66.3164 93.7497 66.2187 97.2191 64.5084C97.3168 64.4596 97.4634 64.3619 97.4389 64.1908",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1733 60.0862C55.0477 61.0879 53.142 62.505 51.1141 63.6533C48.8419 64.9238 46.4475 65.95 43.7599 65.8034C41.8542 65.7056 39.9973 65.2659 38.3359 64.1908",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3644 76.7488C67.4133 79.363 66.9979 81.9529 66.9491 84.5427C66.9246 86.2774 67.0224 88.0121 67.1689 89.7224C67.2178 90.3821 67.1934 91.0173 67.1445 91.677",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4415 76.9685C68.3926 79.5095 68.808 82.026 68.8568 84.5425C68.8813 86.3505 68.808 88.1585 68.6125 89.9421C68.5636 90.5285 68.8568 91.1149 68.5392 91.6768",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.754 107.786C114.562 112.599 117.06 116.794 119.601 121.241C119.723 121.436 119.967 121.68 119.845 121.998",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9936 107.265C21.2344 112.347 18.4491 116.94 15.957 121.656",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.922 92.9719C66.7021 94.7555 66.8487 96.5146 67.0197 98.2738C67.1663 99.7397 66.9464 101.181 66.58 102.598C66.3601 103.38 66.3601 104.113 66.6044 104.871",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8778 93.1917C69.1466 94.9996 68.9267 96.8076 68.7801 98.5912C68.6579 99.9839 68.9267 101.352 69.2443 102.696C69.4153 103.453 69.4886 104.137 69.2199 104.87",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7018 105.751C66.3597 106.85 66.7018 107.925 66.8484 109C67.0438 110.491 67.2149 111.957 67.2393 113.447C67.2393 114.278 67.3859 115.059 67.6791 115.817",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5199 137.023C73.4221 138.049 74.2284 138.684 74.5949 139.515C75.6699 141.885 76.4373 143.505 76.7061 146.119",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0984 105.97C69.4893 107.021 69.074 108.072 68.9518 109.098C68.7808 110.539 68.6342 111.981 68.5609 113.422C68.5364 114.253 68.4143 115.035 68.1211 115.792",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7467 134.311C64.1114 134.702 63.5495 135.191 63.012 135.728C62.3523 136.388 62.2546 137.292 61.9125 138.098C61.375 139.32 60.5932 140.395 60.1778 141.665C59.6159 143.376 58.8585 145.037 58.7852 146.87",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0703 46.452C66.9743 44.7173 67.3408 42.8848 67.2675 40.9303C67.2431 39.9285 67.1453 38.9024 67.463 37.9006C67.5607 37.6074 67.463 37.3387 67.9272 37.3631C68.3425 37.3876 68.3181 37.6074 68.367 37.9006C68.6846 39.3421 68.5136 40.7837 68.5624 42.2252C68.6113 43.7155 69.0266 45.1326 69.7596 46.452",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2614 35.6292C66.5057 38.3656 66.5546 41.0531 65.4062 43.643",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5146 35.6292C69.3191 38.3411 69.1725 41.0776 70.3697 43.643",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5846 45.3782C53.0454 45.1338 51.5794 44.6208 50.0402 44.3764C49.0873 44.2298 48.1589 44.181 47.2305 44.0833",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.569 44.1809C86.028 44.2053 83.6092 44.8406 81.2148 45.598",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M79.042 45.9148C76.7209 46.55 74.4243 47.2341 72.543 48.8467",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4237 216.136C60.3748 218.824 61.3033 221.121 63.1357 223.051C63.2823 223.197 63.3556 223.344 63.4533 223.491",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3281 74.4773C48.4032 77.2626 49.9913 79.7303 51.9703 81.9536",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1347 48.5052C61.1801 47.2103 59.03 46.3063 56.7578 45.7932",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4468 74.697C87.2985 77.3602 85.9303 79.9011 83.8047 81.9534",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1508 216.485C75.1997 219.319 73.898 221.565 71.8945 223.568",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0273 134.531C71.9313 134.971 72.7376 135.557 73.1774 136.486C73.3973 136.95 73.8859 136.877 74.1791 137.219C75.5962 138.929 76.8492 140.339 77.9975 142.244",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0589 137.023C61.4725 137.047 61.1549 137.511 60.8862 137.902C59.9089 139.393 58.6139 140.663 57.7344 142.227",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.834 254.007C57.8095 255.766 57.9073 257.574 56.5391 258.991",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6415 254.227C60.6171 255.18 61.1057 256.01 61.2523 256.914C61.3989 257.745 61.3989 258.454 61.0813 259.187",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M59.786 254.445C60.2257 256.277 59.4195 257.841 58.7109 259.429",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9631 254.007C77.8653 255.766 78.0119 257.476 79.0381 258.991",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0095 254.667C75.5942 256.426 76.3027 257.941 77.0845 259.431",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1561 254.445C74.9362 255.373 74.7163 256.326 74.4964 257.255C74.3498 257.89 74.2765 258.501 74.5942 259.087",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M89.33 79.6804C88.1817 82.6612 87.351 85.7641 85.543 88.4516",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5703 79.7786C47.4987 82.3928 48.2806 85.056 49.6977 87.4748C49.8443 87.7191 50.1374 87.8168 50.1374 88.11",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.793 84.4451C46.9884 85.5934 47.3549 86.7173 47.4771 87.9145C47.5015 88.2565 47.5259 88.5741 47.4526 88.8918",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M90.717 83.0276C90.6681 83.3696 90.4238 83.6873 90.1795 83.7606C88.6158 84.2981 88.738 85.764 88.5181 86.9368C88.3959 87.572 87.9806 88.2806 88.347 88.9891",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8008 206.387C74.3156 207.169 74.9997 208.513 75.3906 210.077",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M90.085 87.5725C90.1094 87.8413 89.8162 88.0367 89.7429 88.0856C88.0082 88.9407 87.6417 90.7243 86.8355 92.2147C86.6644 92.5079 86.5911 92.8743 86.1758 92.9721",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7148 87.3528C45.7881 87.4994 45.8126 87.6948 45.9347 87.7681C47.5228 88.7454 48.2069 90.358 48.8666 91.9949C48.9888 92.2637 49.2087 92.508 49.4041 92.7523",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8178 206.387C61.474 206.681 61.0831 207.878 60.57 208.904C60.4479 209.148 60.1547 209.49 60.3257 209.857",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0295 35.1892C70.7363 36.4353 71.396 37.4126 71.8846 38.4387",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8719 35.1892C64.7986 36.3375 64.6276 37.437 63.7969 38.3166",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9386 73.9397C90.3278 75.0392 89.3994 75.6255 88.1289 75.6744",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8359 73.9395C45.4956 74.8679 46.2775 75.5764 47.5479 75.4543",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9417 77.8247C89.9889 79.5105 88.4496 80.0725 86.6172 79.9992",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8359 77.8247C45.1536 78.1423 45.4956 78.4599 45.8132 78.802C46.7417 79.8282 47.8656 80.0481 49.1605 79.7793",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0547 83.0276C45.861 83.8339 46.5939 84.8112 47.9866 84.2248",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0234 35.1144C65.4858 34.9434 65.3637 34.5036 65.0949 34.0638C63.9955 32.3047 63.9222 30.3257 63.5312 28.3955",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9102 17.3774C58.1545 18.6968 59.3272 18.9655 60.3045 19.4053C61.4773 19.9428 62.6989 19.894 63.8717 19.2099C64.3114 18.9655 64.8001 18.8434 65.2643 18.6479",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8229 17.3774C76.6501 19.3809 74.158 20.2849 72.1057 19.4053C71.5682 19.1854 70.933 19.0633 70.4688 18.6724",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3516 22.7769C59.3289 23.7542 60.2573 24.7803 61.2835 25.6843C62.1142 26.4173 62.2852 27.1991 61.821 28.2008C61.5766 28.7139 61.4545 29.2759 61.259 29.8134",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1629 22.9961C76.1612 23.9734 75.135 24.9507 74.1333 25.928C73.498 26.5388 73.4247 27.1985 73.7912 28.0047C74.06 28.6155 74.1821 29.2997 74.3532 29.9349",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9863 28.4209C71.7909 30.3755 71.6932 32.3789 70.4471 34.0404C70.2761 34.2847 70.4471 34.4068 70.4471 34.6023",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2332 20.1875C73.9872 21.2625 72.4724 21.9466 71.1286 22.8995C70.8842 23.0705 70.5911 23.1683 70.2734 23.1194",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4961 20.4067C61.8643 21.2863 63.3058 22.0437 64.6252 22.9721C64.7473 23.0454 65.0405 23.5097 65.3581 23.1187",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6594 31.0107C66.731 31.646 66.169 32.4767 66.0469 33.6006",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1953 31.1084C68.8794 31.7925 69.3925 32.5743 69.7101 33.4783",
    stroke: "#7689B1",
    strokeWidth: 0.273793,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3511 72.5962C93.0091 72.9871 93.1313 73.4513 93.1313 73.8911C93.1313 77.2384 93.1557 80.5856 92.2517 83.8351C91.5187 86.4982 90.6636 89.1614 90.0039 91.8489C89.442 94.17 88.4891 96.3689 88.2203 98.7633C87.8783 101.549 88.3425 104.236 89.051 106.875C89.7351 109.416 90.6636 112.006 90.4193 114.547C90.1505 117.088 91.2744 119.067 91.8852 121.266C92.5693 123.758 93.1068 126.25 93.2778 128.84C93.571 133.531 93.8398 138.222 93.6199 142.913C93.4977 145.502 93.3511 148.117 93.058 150.707C92.9114 152.001 92.9847 153.296 92.8381 154.591C92.6182 156.668 92.2028 158.72 91.8363 160.748C91.5431 162.336 91.3477 163.925 91.0545 165.513C90.8346 166.783 90.5659 168.029 90.2971 169.3C89.7596 171.963 89.1976 174.626 88.6846 177.313C88.538 178.095 88.2936 178.853 88.0004 179.561C87.3896 180.978 87.1453 182.493 86.5101 183.91C86.1192 184.79 86.3146 185.718 86.2169 186.622C86.0947 187.697 86.0947 188.797 86.0947 189.872C86.0947 191.729 85.8748 193.585 85.4839 195.393C85.0197 197.666 85.2396 199.816 85.9237 202.015C86.5101 203.92 87.2919 205.777 87.7073 207.732C88.5135 211.641 88.88 215.575 88.0249 219.533C87.9271 219.948 87.7073 221.031 87.2941 222.152",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6211 64.3623C38.8183 65.2663 39.649 66.5368 40.6507 67.6118C40.7973 67.7584 40.895 67.9539 41.0905 68.0272C42.6786 68.7113 42.4099 70.0062 42.1655 71.2767C42.1167 71.521 42.0189 71.7898 42.0922 72.0341C42.6786 74.062 42.4098 76.1632 42.4587 78.2155C42.5564 81.0496 43.1917 83.7616 43.9491 86.4248C44.7554 89.2345 45.5128 92.0931 46.4168 94.8784C47.5895 98.4699 47.7605 102.086 46.7099 105.702C46.0014 108.121 45.6838 110.637 45.0485 113.081C44.8531 113.862 44.8287 114.791 45.1707 115.67C45.3173 116.037 45.2929 116.599 45.0974 117.063C44.169 119.506 43.3627 121.998 42.7275 124.539C42.4099 125.81 42.1655 127.129 42.19 128.424C42.2388 130.892 41.9212 133.335 41.9212 135.778C41.9212 137.513 41.5791 139.248 41.7502 140.982C41.9945 143.548 42.0678 146.113 42.361 148.679C42.5076 150.071 42.5076 151.488 42.5564 152.905C42.6297 155.324 43.0695 157.694 43.5093 160.04C43.8758 161.994 44.1934 163.949 44.511 165.903C44.8042 167.614 45.2196 169.275 45.5372 170.985C45.8793 172.94 46.3679 174.87 46.7099 176.825C46.9787 178.413 47.614 179.879 48.1515 181.369C49.0555 183.837 49.4464 186.329 49.3486 188.943C49.2509 191.851 49.8617 194.734 50.3259 197.592C50.4725 198.521 50.3259 199.351 50.0816 200.182C49.4219 202.503 48.7134 204.8 48.0293 207.121C47.5162 208.807 47.3208 210.566 47.1253 212.301C46.9054 214.206 46.9054 216.063 47.1742 217.92C47.3208 218.946 47.1742 217.92 48.1515 221.529",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1235 117.405C88.2195 118.358 87.0712 119.116 86.5581 120.337C86.1672 121.266 85.8007 122.194 85.4343 123.122C84.2859 125.932 82.9422 128.644 81.745 131.454C80.5478 134.312 79.6682 137.269 78.6909 140.201C77.7869 142.913 76.8096 145.625 75.9789 148.337C74.4641 153.223 72.7294 158.036 71.6055 163.045C71.239 164.609 71.1169 166.221 70.3595 167.712C69.993 168.42 70.1151 169.422 70.0907 170.277C70.0663 172.378 70.0418 174.455 70.0907 176.556C70.1884 180.123 70.2373 183.69 70.5061 187.282C70.8237 191.558 71.3612 195.809 72.6072 199.938C72.7294 200.304 72.7538 200.695 72.7538 201.037C72.8516 202.894 74.0732 204.262 74.7084 205.875C75.0993 206.877 75.1727 207.878 75.2215 208.831C75.3925 211.421 75.3925 214.035 75.1482 216.625C75.1238 216.992 75.0749 217.358 75.0749 217.7C75.1482 224.346 74.4641 230.967 74.4641 237.613C74.4641 239.445 73.7986 242.258 73.2855 244.066",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0955 168.33C69.8092 166.93 69.847 166.269 69.8715 165.659C70.0181 162.263 69.7005 158.866 69.6027 155.495C69.5294 152.636 69.0896 149.802 68.943 146.943C68.8453 145.038 68.7476 143.108 68.3567 141.202C68.2589 140.786 68.1857 140.371 67.697 140.347C67.2084 140.322 67.3305 140.762 67.2572 141.08C66.8419 142.814 66.7441 144.598 66.622 146.381C66.4509 148.776 66.2066 151.146 66.0356 153.54C65.889 156.008 65.7424 158.5 65.718 160.992C65.6935 163.24 65.7424 165.488 65.2293 167.711C65.1072 168.273 65.3515 168.933 65.4248 169.543C65.6447 171.84 65.6202 174.161 65.4981 176.458C65.1805 182.517 65.156 188.625 64.2032 194.635C63.91 196.541 63.3969 198.423 62.8838 200.255C62.2486 202.454 62.3463 204.555 63.0548 206.656C64.2765 210.321 64.8873 214.059 64.643 217.92C64.5697 219.214 64.252 220.534 64.0077 221.804C63.6656 223.661 63.6901 225.567 63.3725 227.424C63.0304 229.403 62.9571 231.406 62.6884 233.361C62.3219 235.951 62.1508 238.565 62.3219 241.155C62.444 242.938 62.1264 244.697 62.4929 246.457C62.5906 246.921 62.4685 247.336 62.102 247.776C60.7338 249.413 59.1945 250.854 57.5331 252.198C56.9956 252.638 56.4337 253.127 56.3359 253.908",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2748 135.802C49.4441 138.172 48.6867 140.567 48.2225 143.059C47.856 144.964 47.3673 146.87 47.0497 148.8C46.6344 151.292 46.4145 153.809 46.5611 156.374C46.7077 158.647 46.8054 160.919 47.0253 163.191C47.2452 165.414 47.6361 167.589 48.0026 169.788C48.2958 171.522 48.3935 173.257 48.76 174.992C49.3708 177.948 50.2259 180.831 50.9589 183.739C51.4231 185.571 52.1805 187.355 52.7669 189.163C52.9868 189.847 53.5243 190.238 53.8419 190.8C55.2834 193.414 56.1874 196.199 55.8942 199.229C55.8454 199.669 56.0408 200.304 55.2346 200.573C55.0147 199.571 54.8192 198.594 54.5993 197.592C54.1595 195.442 53.5976 193.341 53.109 191.19C53.0601 190.922 52.8158 190.629 53.0845 190.335",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8077 118.481C88.8322 119.214 88.7344 119.923 88.3679 120.534C87.5128 121.877 87.3662 123.392 87.2196 124.882C86.9264 127.863 86.5355 130.844 85.4116 133.629C84.8008 135.12 85.3628 136.39 85.8025 137.636C87.073 141.35 87.7571 145.186 88.4657 149.022C89.2475 153.224 88.9299 157.451 88.5878 161.678C88.2946 165.269 87.635 168.812 87.1463 172.379C86.4622 177.461 84.923 182.347 83.4082 187.21C83.0905 188.236 82.9195 189.506 82.3087 190.141C81.2825 191.241 80.8183 192.536 80.2564 193.806C79.499 195.565 79.2302 199.059 79.8899 200.501C80.2564 200.599 80.3786 200.208 80.403 200.061C80.9161 196.958 81.8689 193.953 82.3576 190.874C82.382 190.777 82.2843 190.655 82.2598 190.557",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9424 72.498C41.3316 73.4998 41.356 74.6725 41.2338 75.7476C40.9895 77.8487 40.4276 79.8522 39.9878 81.9045C39.4258 84.4699 38.815 87.0353 38.2775 89.6007C38.1065 90.3581 38.3753 91.1155 38.473 91.8729C38.6929 93.461 38.0088 94.8048 37.398 96.1975C36.4695 98.3231 35.932 100.62 35.1257 102.794C33.7575 106.386 31.6563 109.586 29.5307 112.763C27.2585 116.183 24.3022 119.091 22.1277 122.584C21.3703 123.806 20.5396 124.954 20.1487 126.371C19.9777 127.031 20.2708 127.544 20.3441 128.106C20.6862 130.476 20.5152 132.748 19.8066 135.045C18.8538 138.148 17.5589 141.104 16.4105 144.109C16.2639 144.5 16.0685 144.891 15.7753 145.209C15.4332 145.575 15.1156 145.673 14.6758 145.331C14.3093 145.062 14.2849 144.94 14.4315 144.427C15.0668 142.448 15.9463 140.542 16.6304 138.588",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5703 72.5962C94.2544 73.7934 94.2056 75.186 94.401 76.5054C94.7431 78.8997 95.5005 81.172 95.9403 83.5419C96.3067 85.6187 97.2596 87.5977 97.113 89.6989C96.9664 92.2643 97.2596 94.6098 98.3835 96.9797C99.6051 99.5696 100.216 102.453 101.413 105.091C102.708 107.974 104.516 110.491 106.226 113.081C108.67 116.77 111.797 119.922 114.118 123.684C114.827 124.833 115.608 126.005 115.291 127.471C115.071 128.473 115.022 129.475 114.949 130.501C114.802 132.578 115.535 134.435 116.073 136.34C116.879 139.101 118.198 141.667 119.2 144.354C119.664 145.576 120.128 145.722 121.13 145.234",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M58.951 81.0251C59.0487 84.9832 58.6334 88.8924 58.2914 92.826C57.9982 96.2465 57.7294 99.6671 57.876 103.112C57.9249 104.529 57.7538 105.922 57.8271 107.339C57.9493 109.807 58.5112 112.176 58.9755 114.595C59.4641 117.087 59.8795 119.604 60.5636 122.072C61.3943 125.028 62.3227 127.96 63.9352 130.623C64.033 130.77 64.0085 130.916 64.033 131.063",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5898 81.0249C76.5654 85.3006 76.9563 89.5518 77.3228 93.8031C77.445 95.2446 77.6404 96.6861 77.5671 98.1276C77.445 100.253 77.6404 102.379 77.787 104.504C77.9825 107.485 77.4938 110.393 76.883 113.251C76.3699 115.597 76.0035 117.967 75.4171 120.288C74.4886 124.026 73.3647 127.666 71.4102 130.989",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5424 46.7217C47.6873 47.4791 47.3453 48.5541 46.9299 49.5314C44.9997 54.0758 42.4099 58.0827 38.2564 60.868C35.5444 62.7005 33.5165 65.1681 31.6108 67.7335C30.8778 68.7108 30.6579 70.0791 30.267 71.2762C29.4119 73.8661 29.534 76.6025 29.2408 79.2656C28.9476 82.1487 28.8255 85.1294 26.6999 87.5238C25.7959 88.5255 25.1362 89.7227 24.4032 90.871C22.0577 94.5359 20.5918 98.5428 19.6389 102.77C19.1014 105.091 18.6616 107.436 17.9286 109.708C17.5377 110.881 17.0002 111.981 16.4138 113.056C15.5343 114.668 15.3144 116.525 14.8013 118.26C14.1905 120.361 13.1887 122.193 11.5273 123.659",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0703 46.6255C88.4141 48.6289 89.1471 50.9256 90.271 53.0268C92.2255 56.7161 95.1086 59.4769 98.4314 61.8713C100.777 63.5327 102.634 65.7072 104.075 68.1016C105.028 69.7141 105.468 71.7176 105.81 73.6722C106.225 76.1398 106.201 78.6564 106.47 81.1485C106.787 83.9582 107.765 86.3281 109.45 88.5026C111.503 91.1169 113.018 94.0488 114.215 97.1517C115.045 99.3262 115.607 101.574 116.072 103.846C116.829 107.609 117.426 111.004 119.137 114.449C119.479 115.108 120.195 116.223 120.537 118.091",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2983 120.85C49.2005 121.241 49.3716 121.607 49.5182 121.925C51.0086 125.296 52.6211 128.595 54.0382 132.015C55.1621 134.703 55.9439 137.537 56.8235 140.322C57.7519 143.254 58.7781 146.162 59.7065 149.093C60.9037 152.905 62.2963 156.668 63.2736 160.577C63.7867 162.653 64.205 163.501 64.6448 165.603C64.6936 165.871 65.0073 167.91 65.1294 168.081",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2204 203.529C72.634 206.363 71.5589 209.075 71.1436 211.958C70.826 214.303 70.7282 216.649 70.9726 218.995C71.0947 220.192 71.2658 221.413 71.5834 222.562C71.9499 223.808 71.7788 225.103 71.9743 226.349C72.3897 229.061 72.6584 231.822 72.9272 234.558C73.1471 236.83 73.0493 239.102 73.0738 241.375C73.0982 242.67 73.3914 243.94 73.1226 245.284C72.9027 246.359 72.8294 247.409 72.0232 248.338C71.2169 249.291 70.8504 251.856 71.1192 253.078C71.168 253.322 71.3146 253.591 71.2413 253.835C70.5817 256.254 70.7283 258.722 70.7038 261.189C70.7038 261.409 70.6794 261.629 70.7038 261.849C70.8015 262.46 70.1663 263.217 70.9237 263.681C71.7788 264.194 72.7806 264.268 73.709 264.072C74.1976 263.975 74.6374 263.926 75.1261 263.999C75.9079 264.097 76.2255 263.73 76.1034 262.924C75.8346 261.263 75.2971 261.067 73.8312 262.069",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3311 203.334C79.7185 204.8 79.3276 206.877 78.5213 208.758C77.6173 210.835 77.7639 213.058 77.6662 215.257C77.5685 217.822 77.6662 220.388 77.6418 222.929C77.6173 225.054 77.6418 227.18 77.5196 229.306C77.3241 232.799 76.8355 236.293 76.0048 239.689C75.4429 242.035 75.1741 244.454 74.832 246.824",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4062 203.652C56.0432 205.338 56.5807 207.586 57.3137 209.712C57.7535 210.982 57.8024 212.35 57.7779 213.718C57.7535 216.308 57.9734 218.923 57.9489 221.512C57.9245 223.931 57.9489 226.35 58.0711 228.769C58.2666 232.043 58.5598 235.292 59.3172 238.517C59.9524 241.156 60.4655 243.868 60.5632 246.629",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8874 49.8747C63.4215 47.8223 62.2731 45.599 61.3203 43.2779C60.685 41.7631 60.0009 40.2727 59.5123 38.7091C59.3168 38.0494 58.5594 38.538 58.5838 37.9517C55.3343 39.7352 52.2314 41.5921 48.9575 43.1802C47.0029 44.1331 44.8284 44.4018 42.7761 45.1103C40.8459 45.7945 38.9158 46.5519 37.1566 47.6025C34.9088 48.9462 33.5651 50.9741 32.6122 53.3441C31.586 55.9095 30.7553 58.5237 30.34 61.2357C29.9979 63.5568 30.34 65.8046 31.3173 67.9546",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9102 37.9756C79.4756 39.3927 82.0654 40.7364 84.5819 42.2268C86.4632 43.3263 88.4911 43.9127 90.5434 44.499C93.4998 45.3053 96.4317 46.2093 98.9726 47.9684C101.001 49.3855 102.344 51.5111 103.151 53.8078C104.006 56.2266 104.861 58.6698 105.154 61.2597C105.423 63.5807 105.154 65.853 104.177 68.0274",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4961 135.802C51.5223 138.026 52.1086 140.396 52.7927 142.717C53.6479 145.624 54.5519 148.532 55.8712 151.292C57.3372 154.395 58.9986 157.425 60.1225 160.699C61.0509 163.411 61.735 166.196 62.639 168.908C63.4697 171.351 64.3099 173.374 64.5542 175.988C64.5786 176.355 64.741 177.218 65.3324 178.074",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0182 135.9C84.4074 136.609 84.2363 137.562 83.9676 138.392C82.9903 141.471 82.2085 144.623 81.1334 147.701C80.3516 149.949 79.2766 152.05 78.2993 154.176C77.1754 156.643 76.0026 159.062 75.1231 161.628C73.877 165.293 72.973 169.055 71.6048 172.696C71.1162 173.99 70.8477 175.296 70.7011 176.689C70.6299 177.365 70.3097 177.905 70.1875 178.027",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0595 15.9863C78.6197 14.7891 79.206 13.6408 79.4504 12.5414C79.7924 10.9044 79.3526 9.48731 78.8151 8.09466C77.5935 5.01618 75.2969 2.86613 72.2428 1.59565C71.3632 1.22916 70.4104 1.00927 69.4331 1.0337C67.5518 1.107 65.6461 0.764945 63.8136 1.35132C59.7334 2.67067 57.1436 5.43153 56.0197 9.56061C55.6288 11.0266 55.8242 12.4436 56.1174 13.8851C56.264 14.5204 56.5328 15.1801 56.1174 15.8397",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1759 203.432C61.0031 204.751 60.4167 206.364 60.3679 208.074C60.2701 211.544 60.2457 215.013 60.3679 218.458C60.5633 224.346 60.8565 230.21 60.9542 236.098C60.9787 238.59 61.5343 242.184 62.2673 244.627",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8729 208.074C85.8241 209.784 86.2394 211.47 86.4593 213.156C86.7525 215.208 86.7769 217.285 87.0946 219.337C87.29 220.534 87.1679 221.732 87.1923 222.904C87.2167 224.688 86.6792 226.325 86.1661 227.986C85.1888 231.187 84.1382 234.363 83.0388 237.515C82.4524 239.176 81.7439 240.765 81.3041 242.499C80.791 244.527 80.058 246.531 79.6427 248.583C79.4472 249.487 79.4961 250.513 79.7648 251.515C79.9114 252.126 79.7648 252.347 79.4961 253.567",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6484 68.0518C95.1371 69.1756 94.7706 70.3728 94.9661 71.5212C95.4791 74.5752 95.6502 77.7026 96.8474 80.61C97.7758 82.8822 99.0463 84.9834 100.634 86.8891C100.952 87.2801 101.392 87.5732 101.807 87.8664C102.736 88.5017 103.713 88.2329 104.299 87.2312C104.959 86.0829 105.13 84.8368 105.301 83.5419C105.545 81.5629 105.594 79.5839 105.399 77.5804",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7505 68.0518C40.6039 70.0063 40.4573 71.9609 40.2374 73.8911C39.651 78.7532 38.1606 83.1998 34.8134 86.8647C34.1537 87.5977 33.3963 88.4284 32.3457 88.1352C31.2951 87.842 30.9775 86.7914 30.7088 85.7897C30.0735 83.5908 29.9514 81.343 30.1712 79.0708C30.2201 78.5821 30.1712 78.069 30.1712 77.556",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7388 208.074C49.3479 210.884 48.8837 213.669 48.6394 216.503C48.5172 217.945 48.4195 219.386 48.2729 220.828C48.1019 222.562 48.3218 224.322 48.7615 226.007C49.8121 230.039 51.1559 233.997 52.6219 237.882C53.8679 241.155 54.6009 244.552 55.7248 247.85C56.2134 249.267 55.7736 250.611 55.7981 251.979C55.8225 252.688 55.7248 252.596 56.2134 254.031",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2891 186.012C71.4845 187.209 72.0953 188.113 72.8527 189.09C74.8073 191.558 76.2977 194.319 76.7864 197.495C77.0062 198.985 76.6886 200.476 76.3466 201.917C76.1755 202.626 75.3937 202.723 74.8562 202.137C74.1232 201.355 73.83 200.329 73.5613 199.327C72.9993 197.104 72.2175 194.93 72.1198 192.633C72.0465 191.143 71.5578 189.701 71.8022 188.186",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4962 188.284C61.7615 189.921 60.6621 191.973 59.7092 194.123C58.6586 196.469 58.5365 198.888 59.074 201.38C59.1717 201.844 59.2694 202.43 59.8314 202.552C60.3445 202.65 60.6376 202.235 60.9064 201.819C61.6638 200.744 61.786 199.45 62.2258 198.252C63.3008 195.272 63.5207 192.144 63.765 189.041C63.8627 187.966 63.7894 186.916 64.4735 186.012",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6055 49.8735C74.855 50.6554 77.6891 52.2679 80.3523 54.2225C82.8199 56.0061 85.1166 58.034 87.4132 60.0374C89.0991 61.5278 91.0537 62.5784 93.3503 63.0182C95.5492 63.4091 97.7481 63.8733 99.8737 64.6796C100.558 64.9483 101.047 65.6813 101.926 65.4858",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8145 49.8735C60.7604 50.7042 58.024 52.1457 55.4831 53.9782C53.0398 55.7373 50.621 57.5453 48.4954 59.6465C46.0277 62.0409 43.0225 62.9449 39.7974 63.5068C38.1116 63.8 36.4746 64.2887 34.9354 65.0461C34.5689 65.2171 34.2269 65.2415 33.8359 65.2415",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9827 71.3022C90.9827 73.9409 91.0315 76.5796 90.9582 79.1939C90.8116 84.1537 90.0054 88.9913 88.0508 93.5846",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.562 71.3022C44.22 72.6949 44.5376 74.112 44.5132 75.529C44.4887 77.166 44.562 78.8519 44.6353 80.5133C44.8308 84.6423 45.5882 88.6492 47.0541 92.534C47.1763 92.9005 47.3962 93.2181 47.3718 93.609",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3378 124.319C13.09 123.44 11.0621 123.635 8.91204 124.906C7.05518 126.005 5.88242 127.495 4.92956 129.303C4.12329 130.843 2.99939 132.187 1.89994 133.53C1.70448 133.775 1.46016 133.97 1.2647 134.19C0.97151 134.508 0.947081 134.947 1.06924 135.265C1.24027 135.631 1.72891 135.705 2.11983 135.583C2.9261 135.338 3.75681 135.167 4.41648 134.532C5.24719 133.75 6.10232 133.091 6.73756 132.064C7.34837 131.063 8.42339 130.379 9.27852 129.548",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M120.199 124.442C122.178 123.391 124.133 123.562 126.039 124.564C128.091 125.615 129.557 127.252 130.607 129.304C131.536 131.112 132.88 132.627 134.175 134.19C134.37 134.435 134.517 134.679 134.639 134.923C133.881 135.656 132.66 135.754 131.805 135.046C131.243 134.606 130.656 134.215 130.143 133.677C129.801 133.311 129.557 132.798 128.97 132.7",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7538 32.2329C74.047 32.7704 73.8271 33.2835 73.6316 33.7477C71.9214 37.6813 71.2373 41.9081 70.1134 45.9884C69.6736 47.5765 68.9895 49.1157 68.6719 50.7282",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7585 32.5522C61.6363 32.7721 61.6608 32.9676 61.7585 33.2119C63.4199 37.5609 64.3972 42.1297 65.5455 46.6253C65.912 48.018 66.5473 49.3129 66.8404 50.73",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M56.457 253.958C56.7991 254.08 57.0923 254.007 57.3122 253.738C58.5094 252.394 59.7554 253.029 60.8549 253.762C62.0276 254.544 63.0293 255.57 64.2265 256.352C64.5686 256.572 64.6663 257.061 64.6419 257.427C64.5197 258.991 64.9351 260.53 64.8862 262.094C64.8373 263.804 64.7885 263.902 63.1515 264.146C62.052 264.293 61.0015 263.829 59.902 264C59.4622 264.073 59.0713 263.511 59.2668 262.973C59.8287 261.385 59.9997 261.068 61.7344 262.094",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6133 118.481C46.6377 119.752 47.4684 120.778 47.8105 121.951C48.4457 124.247 48.4457 126.642 48.8855 128.987C49.1787 130.6 49.6429 132.164 50.1071 133.727C50.2782 134.314 50.4492 134.851 50.4003 135.462",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2184 120.654C85.7298 120.409 85.5832 120.874 85.3633 121.093C83.5797 122.828 81.7473 124.538 79.8415 126.175C77.2761 128.399 74.3443 130.109 71.5101 131.893C71.3146 132.015 71.0703 132.088 70.8749 132.235C69.8976 132.87 69.751 132.87 69.36 131.795C69.0424 130.915 68.6515 130.036 68.4805 129.083",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4883 117.405C47.2946 118.505 48.3207 119.409 49.1514 120.484C49.7378 121.241 50.8128 121.705 51.5947 122.463C53.7447 124.54 55.8703 126.69 58.4113 128.302C60.5614 129.67 62.6137 131.185 64.8614 132.358C65.6189 132.749 65.7899 132.578 66.0831 131.991C66.5473 131.063 66.7427 130.037 67.0604 129.06",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44867 132.871C6.57083 133.042 6.66855 133.188 6.66855 133.408C6.66855 135.754 6.71742 138.099 6.64413 140.445C6.59526 142.204 6.47309 143.987 6.42423 145.746C6.3998 146.504 6.57083 147.212 6.69299 147.897C6.91289 149.069 7.64585 148.165 8.18336 148.116",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8272 38.3911C58.8028 40.0525 58.8516 41.7139 58.534 43.3753C58.2408 44.7924 57.3368 45.5254 56.1152 45.9407C55.4067 46.1851 54.747 45.843 54.4049 45.1833C54.1851 44.7191 54.5271 44.3038 54.918 44.0106C56.2129 43.0577 57.3124 41.9338 58.1675 40.5412",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5898 38.3911C76.8097 39.9059 76.6387 41.4207 76.9075 42.9355C77.1518 44.3038 77.8115 45.3055 79.082 45.843C79.9127 46.185 80.6701 45.9407 81.0121 45.2078C81.3542 44.4504 80.7678 44.0839 80.2547 43.6929C79.1308 42.8134 78.0314 41.9094 77.445 40.5656",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M122.034 139.247C122.312 139.91 122.425 140.053 122.547 140.444C123.231 142.887 123.842 145.331 124.379 147.798C124.452 148.116 124.746 148.287 124.746 148.605C123.719 149.509 123.426 149.46 122.693 148.238C121.765 146.723 121.325 145.013 120.739 143.376C120.177 141.812 119.615 140.249 118.906 138.709",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5212 92.6069C36.324 94.3661 34.8336 95.8564 33.0745 97.0292C30.5335 98.715 28.2369 100.694 25.8669 102.6C25.3538 103.015 25.0362 103.773 24.7675 104.408C23.9123 106.509 22.4952 108.244 21.0537 109.905C19.1236 112.104 17.3472 114.293 15.7591 116.736C15.6614 116.883 15.4011 117.18 15.0977 117.452",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0156 92.5088C99.2861 94.781 101.29 96.3202 103.415 97.7129C105.687 99.2033 107.715 101.036 109.792 102.795C110.281 103.21 110.501 103.845 110.745 104.432C111.82 106.924 113.604 108.903 115.338 110.906C116.706 112.494 117.83 114.254 119.125 115.891C120.225 117.283 120.933 118.798 121.495 120.459C121.935 121.754 123.034 122.658 123.865 123.709",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M126.457 129.622C127.239 130.501 128.436 131.136 128.754 132.236C128.998 133.067 128.68 134.093 128.729 135.021C128.9 138.148 128.827 141.3 128.998 144.428C129.047 145.454 128.778 146.456 128.949 147.457C129.047 148.019 128.607 148.239 128.314 148.532C127.923 148.41 127.63 148.117 127.214 148.117",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0584 85.1541C38.0584 85.9603 37.8141 86.7422 37.6919 87.524C37.5453 88.6235 37.1055 89.6496 36.0061 90.236C34.8333 90.8712 33.685 91.6042 32.5367 92.2883C30.7776 93.3145 29.3605 94.7071 27.8945 96.0753",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5781 85.1541C97.7247 86.8399 97.6514 88.6235 99.0929 89.9184C99.5572 90.3337 100.119 90.7002 100.632 90.969C103.149 92.1906 105.348 93.8031 107.204 95.8799C107.302 96.002 107.4 96.002 107.522 95.9776",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7652 72.693C62.7845 72.5953 59.9503 73.5482 56.994 73.8169C55.7724 73.9147 54.5263 73.7192 53.3047 73.988",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1953 113.618C46.0504 113.667 46.6613 114.229 47.2232 114.718C48.6158 115.915 50.2773 116.623 51.9142 117.381C53.0137 117.894 53.8933 117.405 54.4063 116.208C54.7973 115.329 55.0171 114.425 55.1637 113.496",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1297 69.3463C92.2746 69.3218 91.8348 70.0793 91.1996 70.4457C90.1001 71.0565 89.0495 71.9117 87.9256 72.3026C86.4597 72.8157 84.9205 73.2066 83.4056 73.5975C80.6448 74.3061 77.9816 73.7197 75.2941 73.3532C73.4861 73.1089 71.727 72.5469 69.8945 72.6935",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3988 253.762C79.3744 255.497 80.596 256.596 81.5733 257.745C82.8193 259.186 84.6029 259.797 86.3132 260.481C87.1439 260.799 87.5592 261.947 87.1683 262.851C86.8262 263.584 86.2399 263.902 85.458 263.511",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2242 113.619C88.8559 113.985 87.9764 115.158 86.7792 115.793C85.7042 116.355 84.6536 116.941 83.5297 117.381C82.4547 117.797 81.6484 117.381 81.1597 116.306C80.7688 115.451 80.5734 114.523 80.4023 113.594",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8873 25.1964C78.7424 25.2697 79.2799 24.6589 79.5976 24.097C80.8192 21.8247 81.9186 19.4792 81.601 16.7428C81.5277 16.0587 81.1612 15.6189 80.5993 15.4723C79.9885 15.3257 79.4754 15.7411 79.1089 16.2053C78.718 16.6695 78.5225 17.1826 78.547 17.8178C78.6936 20.5298 78.1805 23.193 77.643 25.8072C77.5452 26.3447 77.5453 26.9067 77.3498 27.4442C77.0322 28.2749 76.6657 29.0079 75.9571 29.6431C74.2957 31.1091 73.0497 33.0148 71.2661 34.3586C69.6536 35.5802 67.8456 35.9467 65.8666 35.3359C65.6711 35.287 65.5245 35.1893 65.4023 35.0671",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8911 34.9462C63.474 34.4331 62.6922 33.1626 61.6904 32.2098C60.7376 31.2813 59.858 30.304 58.8807 29.4C58.1966 28.7404 57.9034 27.6409 57.7568 26.6392C57.317 23.7317 56.6085 20.8487 56.8528 17.8679C56.9017 17.1838 56.5352 16.5486 56.0954 16.0599C55.7778 15.6935 55.2647 15.4003 54.7028 15.498C54.0431 15.6446 53.7743 16.2554 53.6522 16.7929C53.1635 18.8452 55.0693 24.0005 56.6574 25.0266C56.9261 25.1977 57.1704 25.1977 57.4392 25.2221",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9091 29.0815C77.1534 29.5946 76.958 30.0833 76.9091 30.5964C76.7625 32.6487 76.6892 34.701 76.6892 36.7533C76.6892 37.1442 76.6403 37.5596 76.8358 38.0238C76.0295 38.317 75.8829 39.0744 75.5897 39.7829C74.2948 42.9836 73.0732 46.2087 71.143 49.0917C70.972 49.3604 70.8987 49.7758 70.5078 49.8491",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M106.67 86.23C106.499 88.209 107.134 90.1147 107.305 92.0693C107.427 93.3642 107.72 94.6347 107.696 95.9541C107.671 96.8581 108.331 97.7132 108.551 98.6416C108.795 99.7167 109.162 100.792 109.699 101.793C109.87 102.087 109.748 102.38 109.797 102.673",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8462 86.23C28.9684 87.8181 28.6263 89.3329 28.4064 90.8721C28.1621 92.5335 28.0888 94.2194 27.7223 95.8319C27.307 97.7865 26.6962 99.7167 25.9143 101.574C25.7922 101.842 25.5478 102.111 25.8166 102.429",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M125.286 138.392C125.726 140.102 125.922 141.837 126.166 143.596C126.337 144.867 126.606 146.137 126.948 147.383C127.094 147.921 127.045 148.409 127.021 148.898C126.997 149.362 126.826 149.802 126.264 149.875C125.775 149.924 125.311 149.924 125.286 149.24C125.286 149.118 125.091 149.02 124.969 148.922",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2636 139.247C12.4817 142.106 11.7488 144.989 11.1624 147.896C10.9914 148.751 10.2095 149.411 9.52542 150.022C8.25494 149.362 8.27937 148.409 8.59699 147.261C9.3544 144.451 9.50099 141.544 10.1362 138.709",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8303 72.498C87.7814 73.5486 86.853 74.0373 86.2666 74.6237C84.3365 76.6027 82.2842 78.4595 79.7188 79.6567",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3718 258.501C61.1484 259.528 58.8762 260.065 56.4574 259.357C55.8222 259.161 55.1869 258.99 54.625 258.624",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1345 258.501C78.2271 260.065 75.3196 259.992 72.3633 258.599",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4805 69.4692C42.7004 69.4203 42.9691 69.4447 43.1157 69.5913C43.36 69.8112 43.5799 70.0067 43.8731 70.1288C46.6584 71.2039 48.2221 73.696 50.2744 75.6506C51.7159 77.0188 53.2063 78.3626 55.0143 79.2421C55.3075 79.3887 55.674 79.3887 55.8938 79.6575",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9474 27.6901C69.7013 26.4929 68.1377 26.4929 66.6229 26.664C65.8654 26.7373 65.0347 26.9816 64.3262 27.4702C63.7887 27.8123 63.7887 28.2032 64.1307 28.5697C66.4518 30.9152 69.5547 30.3288 71.0451 28.5941C71.265 28.3498 71.3383 28.1055 71.1428 27.8123C68.8706 28.472 66.574 28.8873 64.3262 27.7146",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7577 67.0742C32.7577 67.8316 32.3668 68.4669 32.0981 69.1265C31.3651 70.9834 30.9497 72.938 30.4855 74.8682C30.4366 75.0636 30.6565 75.3568 30.2656 75.4057",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M58.73 29.5215C58.5346 30.5721 58.6079 31.5982 58.73 32.6488C58.9255 34.408 58.9011 36.1915 58.73 37.9507",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M102.562 67.1958C103.906 69.8589 104.615 72.7175 105.152 75.625",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9961 247.483C74.0956 248.339 74.7064 249.658 75.8058 250.513C76.9786 251.393 78.078 252.345 79.0553 253.445",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6027 250.293C72.7755 250.733 73.6062 251.661 74.7545 252.37C73.7283 253.249 72.58 253.567 71.3828 253.762",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6875 72.3765C49.3978 72.6697 50.9614 73.4026 52.6717 73.6714C52.8916 73.6958 52.9893 73.8668 53.0871 74.0134C54.5774 76.1146 56.8985 77.0675 59.0486 78.2402",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2092 74.1104C81.8427 75.2342 80.7433 75.6252 79.937 76.2604C78.9597 77.0422 77.8114 77.5553 76.6875 78.1173",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1507 16.5479C74.3183 17.5007 72.437 17.5251 70.5312 16.8655",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2656 16.646C60.8782 17.3545 62.5396 17.5744 64.2498 16.9881C64.4453 16.9148 64.6896 16.9881 64.8851 16.9881",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2806 254.178C78.8897 254.227 78.6209 254.056 78.3033 253.86C76.5686 252.737 75.7868 252.785 74.1987 254.08C73.368 254.764 72.5373 255.424 71.7066 256.157C71.4867 256.353 71.2912 256.377 71.0469 256.353",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2379 145.21C13.627 146.212 13.4805 147.409 12.7475 148.362C11.9656 149.363 11.9168 149.437 10.8906 148.777",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1824 18.4785C66.0847 19.749 65.8403 20.9706 65.3273 22.1678C64.9363 23.0718 65.2539 23.4383 66.4023 23.5605C66.5733 23.5849 66.6466 23.7071 66.7199 23.7804C67.3063 24.3912 67.8682 24.4889 68.479 23.8048C68.5523 23.7315 68.8211 23.536 69.0898 23.536C70.1404 23.5116 70.0671 23.4872 69.9694 22.461C69.8961 21.5326 69.3097 20.7996 69.2364 19.8712C69.212 19.4314 69.1631 18.9183 69.0898 18.4541",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8975 64.2642C96.5782 65.5591 95.5765 67.1961 94.0128 68.2711C93.4264 68.6864 93.231 69.2484 93.3287 70.0058C93.4508 70.7876 93.2798 71.5939 93.4508 72.3757",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3272 259.821C51.7408 260.505 51.2277 261.213 50.4948 261.775C49.9328 262.215 50.0061 262.997 50.226 263.461C50.4215 263.901 51.1544 263.901 51.6675 263.803C52.205 263.706 52.6693 263.486 52.6693 262.728C52.6448 261.433 53.7443 260.847 54.5017 260.016",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3672 263.071C76.6359 262.948 76.9047 263.242 77.0024 263.315C77.9064 264.17 78.8837 264.146 79.9587 263.73C80.3252 263.584 80.6184 263.901 80.936 263.926C81.6201 263.999 82.5242 264.121 82.8418 263.388C83.0861 262.802 82.8662 262.02 82.4508 261.458C82.0599 260.945 81.5224 260.579 81.1559 260.041",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0307 250.293C64.8614 251.392 64.275 252.589 64.3972 253.787C63.1023 253.469 61.9051 253.371 60.8789 252.467C61.6363 251.563 62.6136 251.026 63.4932 250.439C64.1284 250.024 64.1773 249.609 63.8841 249.12C63.5176 248.485 63.2488 247.752 62.6136 247.263",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0466 263.071C58.1671 263.462 57.5074 264.268 56.3347 263.975C55.3818 263.73 55.2108 263.486 55.5528 262.533C55.7971 261.849 56.5545 261.336 56.3347 260.481",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M118.786 124.979C117.735 125.688 116.562 125.81 115.316 125.737",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4046 260.14C83.9177 260.653 84.4308 261.142 84.9194 261.655C85.066 261.802 85.2126 261.924 85.2615 262.192C85.3592 262.632 85.5058 263.145 85.2126 263.487C84.8217 263.952 84.162 263.854 83.6245 263.805C83.4046 263.781 83.1847 263.536 82.9648 263.39",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8901 15.6681C63.8884 15.0328 62.96 14.1777 61.6406 14.251",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1836 260.457C79.2325 260.995 79.3546 261.508 79.6967 261.996C80.0143 262.436 80.3808 262.949 80.2586 263.609",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 125.076C17.9304 125.614 18.9566 125.907 20.0805 125.614",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5608 14.2764C72.3392 14.1787 71.5329 14.9605 70.6289 15.5713",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0273 123.123C18.8336 123.807 19.9086 123.733 20.8371 124.1",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M117.368 123.244C116.513 123.782 115.511 123.855 114.559 124.1",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3594 120.215C14.8969 121.07 15.7032 121.681 16.4117 122.389",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7695 263.388C53.5269 264.243 54.3821 263.999 55.2616 263.608",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M121.275 120.215C120.493 120.752 120.176 121.803 119.223 122.169",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2539 253.958C64.4494 254.691 65.0357 255.4 64.5715 256.23",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0545 263.487C48.9795 263.804 48.3931 263.389 48.3198 262.289C48.2465 261.263 48.5153 260.652 49.6148 260.31C52.2535 259.455 54.3302 257.867 55.7229 255.375C55.9916 254.911 56.0405 254.398 56.3337 253.958",
    stroke: "#2B4B8E",
    strokeWidth: 0.547586,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyMale);
export default __webpack_public_path__ + "static/media/body-male.4a94b0669e5ee14e0af0ba42296149b3.svg";
export { ForwardRef as ReactComponent };